var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['lebo-query', _vm.isMultiRow ? 'shadow_box' : '']},[_vm._t("default"),(_vm.isMultiRow)?_c('i',{class:['open_box iconfont ', _vm.isOpen ? 'lebo-caret-top' : 'lebo-caret-bottom'],on:{"click":_vm.toggleChange}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }